import React from 'react'
import { particlesRnd } from '../utilities'

export const ParticlesAnimation = React.memo(() => {
  return (
    <div className='position-relative'>
        <div className='bubbles'>
            {
                particlesRnd().map((x, key) => (
                    <span key={key} style={{ '--i': x }}></span>
                ))
            }
        </div>
    </div>
  )
})
